import { cssVar } from 'metrix-common3';

const HierarchyIcon = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40' fill='none'>
        <path
            stroke={cssVar.colorStrokeLight}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M28.333 30H16.667a5 5 0 0 1-5-5V8.333'
        />
    </svg>
);

export default HierarchyIcon;
